import { render, staticRenderFns } from "./detail_tab_sali.vue?vue&type=template&id=a23e33ea&scoped=true"
import script from "./detail_tab_sali.vue?vue&type=script&lang=js"
export * from "./detail_tab_sali.vue?vue&type=script&lang=js"
import style0 from "./detail_tab_sali.vue?vue&type=style&index=0&id=a23e33ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23e33ea",
  null
  
)

export default component.exports